export default __webpack_public_path__ + "static/media/softsagesRFPCoverTemplate.b4e4235f.png";